var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';


    var initializeBlock = function ($block) {


    };

    window.onload = function () {
        initializeBlock($(this));

        let mobileValuesOnLoad = {};
        jQuery('ul[data-to-open]').each(function () {
            if (jQuery(this).find('input:checked').length) {
                mobileValuesOnLoad[jQuery(this).attr('data-to-open')] = jQuery(this).find('input:checked').val();
            } else {
                mobileValuesOnLoad[jQuery(this).attr('data-to-open')] = '';
            }
        });


        let values = {};
        let postPerPage = 9;
        let paged = parseInt(jQuery('.block-product-list__list').data('paged'));
        let maxPages = parseInt(jQuery('.block-product-list__list').data('max-pages'));
        if (jQuery('.block-product-list__list').data('cta') != '1' ){
            postPerPage = 12;
        }
        let notAjax = ['size', 'comfort', 'offer_size', 'offer_comfort'];
        jQuery('.product-filter').on('change', function(){

            values = {};

            jQuery('.product-filter').each(function(){
                values[jQuery(this).attr('name')] = jQuery(this).val();
            });

            if(notAjax.includes(jQuery(this).attr('name'))){

                // console.log('reload page');

                let comfort = '';
                let size = '';
                let currentLocation = new URL(window.location);
                if (values['comfort'] != '' && values['comfort'] != 'any'){
                    comfort = '/' + values['comfort'];
                }
                if (values['size'] != '' && values['size'] != 'any') {
                    size = '/' + values['size'];
                }
                let port = '';
                if (currentLocation.port != ''){
                    port = ':' + currentLocation.port
                }

                if(size == '' && comfort == ''){
                } else {
                    console.log(window.location.protocol + "//" + currentLocation.hostname + port + '/' + currentLocation.pathname.split('/')[1] + comfort + size + '/');
                    window.location.href = window.location.protocol + "//" + currentLocation.hostname + port + '/' + currentLocation.pathname.split('/')[1] + comfort+size+ '/';
                    return;
                }
                // console.log(currentLocation.hostname);
                // console.log(comfort);
                // console.log(size);
                // console.log(currentLocation.pathname.split('/')[1]);


            }


            $('.product-cta').css('display', 'none');
            let data = {
                action: "filter_product_list",
                nonce: sealy_ajax_object.nonce,
                data: values,
                postPerPage: postPerPage,
                maxPages: maxPages,
                paged: paged,
            }
            // console.log(typeof values);
            // console.log(values);
            // console.log(data);

            jQuery.ajax({
                type: "post",
                dataType: "json",
                url: sealy_ajax_object.ajax_url,
                data: data,
                success: function (response) {
                    console.log('response');
                    console.log(response);

                    if (response.success == true) {
                        jQuery('.block-product-list__list').find('.product-item').remove();
                        jQuery('.block-product-list__pagination').empty();
                        response.data.posts.forEach(element => {
                            jQuery('.block-product-list__list').append(element);
                        });
                        if (response.data.posts.length >= 7 && jQuery('.block-product-list__list').data('cta') == '1' ){
                            $('.product-cta').css('display', 'block');
                        }
                        console.log((response.data.pagination != null));
                        if (response.data.pagination != null ) {
                            console.log(response.data.pagination);
                            jQuery('.block-product-list__pagination').append(response.data.pagination);
                        }
                    }
                    else {
                        console.warn("Your vote could not be added");
                    }
                }
            })
        });

        jQuery('.mobile-filters__btn').on('click', function(){
            jQuery('.mobile-filters__container').addClass('mobile-filters__container--show');
        });

        jQuery(".mobile-filters__close, .mobile-filters__mask").on('click', function () {
            jQuery('.mobile-filters__container').removeClass('mobile-filters__container--show');
        });

        jQuery("span[data-open]").on('click', function () {
            let toOpen = jQuery(this).data('open');
            jQuery('.mobile-filters__item__list:not([data-to-open="' + toOpen + '"])').slideUp(200);
            jQuery('.mobile-filters__item__list[data-to-open="' + toOpen + '"]').slideToggle(200);
        });

        jQuery("#applyMobile").on('click', function (e) {
            e.preventDefault();
            values = {};
            let keys = [];
            jQuery('.mobile-filters__item__list[data-to-open]').each(function () {
                if (jQuery(this).find('input:checked').length){
                    values[jQuery(this).attr('data-to-open')] = jQuery(this).find('input:checked').val();
                } else {
                    values[jQuery(this).attr('data-to-open')] = '';
                }
            });



            for (const [key, value] of Object.entries(values)) {
                console.log(`${key}: ${value}`);
                keys.push(key);
            }

            let reloadPage = 0;
            if(mobileValuesOnLoad.size != values.size || mobileValuesOnLoad.comfort != values.comfort){
                reloadPage = 1;
            }


            if (reloadPage) {
                // console.log(mobileValuesOnLoad);
                // console.log(values);
                // console.log('reload mobile');
                // return;
                let comfort = '';
                let size = '';
                let currentLocation = new URL(window.location);
                if (values['comfort'] != '' && values['comfort'] != 'any') {
                    comfort = '/' + values['comfort'];
                }
                if (values['size'] != '' && values['size'] != 'any') {
                    size = '/' + values['size'];
                }
                let port = '';
                if (currentLocation.port != '') {
                    port = ':' + currentLocation.port
                }

                if (size == '' && comfort == '') {
                } else {
                    console.log(window.location.protocol + "//" + currentLocation.hostname + port + '/' + currentLocation.pathname.split('/')[1] + comfort + size);
                    window.location.href = window.location.protocol + "//" + currentLocation.hostname + port + '/' + currentLocation.pathname.split('/')[1] + comfort + size;
                    return;
                }
            }

            $('.product-cta').css('display', 'none');
            jQuery('.mobile-filters__container').removeClass('mobile-filters__container--show');

            let data = {
                action: "filter_product_list",
                nonce: sealy_ajax_object.nonce,
                data: values,
                postPerPage: postPerPage,
                maxPages: maxPages,
                paged: paged,
            }
            // console.log(typeof values);
            // console.log(values);
            // console.log(data);

            jQuery.ajax({
                type: "post",
                dataType: "json",
                url: sealy_ajax_object.ajax_url,
                data: data,
                success: function (response) {
                    console.log('response');
                    console.log(response);

                    if (response.success == true) {
                        jQuery('.block-product-list__list').find('.product-item').remove();
                        jQuery('.block-product-list__pagination').empty();
                        response.data.posts.forEach(element => {
                            jQuery('.block-product-list__list').append(element);
                        });
                        if (response.data.posts.length >= 7 && jQuery('.block-product-list__list').data('cta') == '1') {
                            $('.product-cta').css('display', 'block');
                        }
                        console.log((response.data.pagination != null));
                        if (response.data.pagination != null) {
                            console.log(response.data.pagination);
                            jQuery('.block-product-list__pagination').append(response.data.pagination);
                        }
                    }
                    else {
                        console.warn("Your vote could not be added");
                    }
                }
            });


        });

        jQuery("#clearMobile").on('click', function () {
            jQuery('.mobile-filters__item__list[data-to-open]').hide(200);
            jQuery('.mobile-filters__item__list[data-to-open]').find('input').prop('checked', false);

        });

    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=product-list', initializeBlock);
    }
});
